var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showColors
      ? _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("label", [
            _vm._v(
              _vm._s(_vm.colorsCount) +
                " " +
                _vm._s(_vm.selectedPart.partGroupDescription)
            ),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      [
        _c("DropdownButton", {
          staticClass: "position-relative",
          attrs: {
            id: _vm.selectedPart.partId,
            label: "Select part...",
            customButton: !_vm.dropdownButton,
          },
          on: {
            remove: function ($event) {
              return _vm.$emit("choosePart", null)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "customButton",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn bg-white w-100 border pointer",
                      attrs: {
                        type: "button",
                        id: `submenu-${_vm.selectedPart.partId}`,
                        "data-toggle": "dropdown",
                      },
                      on: { click: _vm.loadData },
                    },
                    [
                      _c("PartsDropdownOption", {
                        attrs: {
                          showSizes: _vm.showSizes,
                          selectedPart: _vm.selectedPart,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "menu",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu w-100 px-2",
                      attrs: {
                        role: "menu",
                        "aria-labelledby": `submenu-${_vm.selectedPart.partId}`,
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.partsSearch,
                            expression: "partsSearch",
                          },
                        ],
                        staticClass: "form-control mr-2 mb-2",
                        attrs: { type: "text", placeholder: "Search parts..." },
                        domProps: { value: _vm.partsSearch },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.partsSearch = $event.target.value
                          },
                        },
                      }),
                      _c(
                        "ul",
                        {
                          staticClass: "list-group",
                          staticStyle: {
                            "max-height": "400px",
                            "overflow-y": "scroll",
                          },
                        },
                        [
                          _vm.loading
                            ? _c(
                                "li",
                                {
                                  staticClass:
                                    "d-flex justify-content-between cursor-pointer p-2 border-bottom",
                                },
                                [_c("loading")],
                                1
                              )
                            : _vm._l(_vm.filteredPartsList, function (part) {
                                return _c(
                                  "li",
                                  {
                                    key: `${part.partId}-${part.updatedAt}`,
                                    staticClass:
                                      "d-flex justify-content-between cursor-pointer p-2 border-bottom",
                                    attrs: { role: "presentation" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("choosePart", part)
                                      },
                                    },
                                  },
                                  [
                                    _c("PartsDropdownOption", {
                                      attrs: {
                                        showSizes: _vm.showSizes,
                                        selectedPart: part,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }